"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styleWholeSelectedBlocksModifier = _interopRequireDefault(require("./styleWholeSelectedBlocksModifier"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const alignments = ['left', 'center', 'right'];
class AlignmentControls extends _react.Component {
  handleToggleAlign(alignment) {
    const _this$props = this.props,
      editorState = _this$props.editorState,
      setEditorState = _this$props.setEditorState;
    const editorStateWithAlignment = (0, _styleWholeSelectedBlocksModifier.default)(editorState, alignment, alignments.filter(align => alignment !== align));
    setEditorState(editorStateWithAlignment);
    this.props.focusEditor();
  }
  hasAlignmentStyle(alignment) {
    const editorState = this.props.editorState;
    const selectionState = editorState.getSelection();
    const block = editorState.getCurrentContent().getBlockForKey(selectionState.getStartKey());
    let alignmentStyle = 'left';
    block.findStyleRanges(e => {
      if (e.hasStyle('center')) alignmentStyle = 'center';
      if (e.hasStyle('right')) alignmentStyle = 'right';
    });
    return alignmentStyle === alignment ? 'active' : null;
  }
  render() {
    const buttonClassName = this.props.buttonClassName;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "alignmentControls"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: (0, _classnames.default)(buttonClassName, this.hasAlignmentStyle('left')),
      onClick: () => this.handleToggleAlign('left')
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-align-left"
    })), /*#__PURE__*/_react.default.createElement("button", {
      className: (0, _classnames.default)(buttonClassName, this.hasAlignmentStyle('center')),
      onClick: () => this.handleToggleAlign('center')
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-align-center"
    })), /*#__PURE__*/_react.default.createElement("button", {
      className: (0, _classnames.default)(buttonClassName, this.hasAlignmentStyle('right')),
      onClick: () => this.handleToggleAlign('right')
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-align-right"
    })));
  }
}
exports.default = AlignmentControls;